import { boolean, number, object } from "utils/yup";

import type { InferType } from "utils/yup";

export const POST_SETTLEMENT_BALANCE_CORRECTION_RESPONSE_SCHEMA = object({
  correctionApplied: boolean().required(),
  correctionAmount: number().required(),
  settlementBalanceBefore: number().required(),
  settlementBalanceAfter: number().required(),
  accountBalance: number().required(),
  reserveBalance: number().required(),
});

export interface PostSettlementBalanceCorrectionResponse
  extends InferType<
    typeof POST_SETTLEMENT_BALANCE_CORRECTION_RESPONSE_SCHEMA
  > {}
